export default {
  API_URL: 'https://flotationenergy-api.cometrootapp.com/api/',
  SANDBOX_URL: 'https://flotationenergysandbox-api.cometrootapp.com/api/'
  // API_URL: 'https://localhost:44365/api',
  // SANDBOX_URL: 'https://localhost:44365/api'
}
